import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios"

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/font/font.css';
import VueAwesomeProgress from "vue-awesome-progress"
import 'fullpage.js/vendors/scrolloverflow';
import VueFullPage from 'vue-fullpage.js';
Vue.use(VueFullPage);
// import echarts from 'echarts'
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts
Vue.use(VueAwesomeProgress)
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.BASEURL = window.BASEURL
Vue.prototype.OUTURL = window.OUTURL

import vueI18n from 'vue-i18n'
Vue.use(vueI18n)
const locale = localStorage.getItem('lang') && ['zh','en','wy','ty','hy','ry','tw','yd','yn'].includes(localStorage.getItem('lang')) ?localStorage.getItem('lang'):'en'
const i18n=new vueI18n({
	locale:locale,
	messages:{
		'zh':require('@/lang/zh'),
		'en':require('@/lang/en'),
		'wy':require('@/lang/wy'),
		'ty':require('@/lang/ty'),
		'hy':require('@/lang/hy'),
		'ry':require('@/lang/ry'),
		'tw':require('@/lang/tw'),
		'yd':require('@/lang/yd'),
		'yn':require('@/lang/yn'),
	}
})
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    if (sessionStorage.getItem('token')) { //判断本地是否存在access_token
      next();
    } else {
      alert("您还没有登录,请先进行登录!")
      next({
        path: '/'
      })
    }
  }
  else {
    next();
  }
});
let vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
//axios的封装
//因为响应拦截中要使用vue实例来调用router方法但是不能声明两次实例所以放到main.js中
const instance = axios.create({
  // baseURL:'https://api.ywsc.info/api',
  // baseURL:'http://shuojiang.net:8002/api',//本地测试
  // baseURL:'http://shuojiang.net:8001/api',//本地正式
  baseURL:window.BASEURL+'api',//本地正式
  // timeout:30000
})
//请求拦截里面
instance.interceptors.request.use(config=>{
  // config.headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
  config.headers = { 'Content-Type': 'multipart/form-data;' }

  return config
}),err=>{
  return Promise.reject(err)
}
instance.interceptors.response.use(res=>{
  if(res.data.code == 9999){
    vm.$router.push('/?a=gq')
  }
  return res.data
},err=>{
  return Promise.reject(err)
})

export default instance